module.exports = __webpack_public_path__ + "img/Recurso 10.11645624.png";